import React from 'react';
import DateRange from './DateRange';
import classes from './TransactionsMenu.css';
import Select from 'react-select';
import { Button } from '@material-ui/core';
import OptionMenu from './OptionMenu';
import Search from './Search';

const TransactionMenu = (
    { isSaving,
        linkClicked,
        isR1,
        isRah,
        account,
        uncodedOnly,
        toggleFilter,
        accounts,
        selectAccount,
        updateRange,
        dateRange,
        setDateRange,
        showRules,
        showModal,
        showRemoveModal,
        toggleDisplayAccount,
        toggleEditableDescription,
        toggleTaxTracking,
        refreshGrid,
        displayAccount,
        editableDescription,
        taxTracking,
        postToRAH,
        reportsMenu,
        onSearchchanged,
        isTransactionToRemove,
        codingErrors
    }) => {

    let bankOptions = accounts.filter(account => account.isBankfeed);
    if (isRah) bankOptions = bankOptions.filter(option => option.RAHBankAccountID);
    if (isR1) bankOptions = bankOptions.filter(option => option.R1BankAccountID);
    const hasFeeds = bankOptions.length > 0;

    return (
    <div>
        <div className={classes.outerWrapper}>
            <div className={classes.menuWrapper}>
                <div className={classes.menuItem}>
                    <Select 
                        placeholder={!hasFeeds ? "No eligible accounts" : "Select Accounts..."}
                        tabIndex={-1}
                        value={bankOptions.find(item => item.value === account.value)}
                        options={bankOptions}
                        blurInputOnSelect
                        onChange={selectAccount}
                        isDisabled={!hasFeeds}
                        />
                </div>
                {(isR1 || isRah) && <div><DateRange updateRange={updateRange} dateRange={dateRange} setDateRange={setDateRange} /></div>}

                <div className={classes.menuItem300}><Search onSearchchanged={onSearchchanged} /></div>

                {!isR1 && !isRah && <div className={classes.menuItem300}>
                        <Button tabIndex={-1} variant="outlined" onClick={() => showModal('revert')}>Revert</Button>&nbsp;&nbsp;
                        <Button tabIndex={-1} variant="outlined" onClick={(event) => reportsMenu(event.currentTarget)}>Reports</Button>&nbsp;&nbsp;
                        <Button tabIndex={-1} variant="outlined" onClick={showRules}>Rules</Button>
                </div>}
            </div>
            <div>
                <OptionMenu
                    uncodedOnly={uncodedOnly}
                    codingErrors={codingErrors.length}
                    tabIndex={-1}
                    toggleFilter={toggleFilter}
                    toggleDisplayAccount={toggleDisplayAccount}
                    toggleEditableDescription={toggleEditableDescription}
                    toggleTaxTracking={toggleTaxTracking}
                    refreshGrid={refreshGrid}
                    displayAccount={displayAccount}
                    editableDescription={editableDescription}
                    taxTracking={taxTracking}
                    isR1={isR1}
                    isRah={isRah}
                    showModal={showModal}
                    showRemoveModal={showRemoveModal}
                    showRules={showRules}
                    isTransactionToRemove={isTransactionToRemove}
                    hasFeeds={hasFeeds} />
                    
            </div>
        </div>

        {!hasFeeds && (
            <div className={classes.no_feeds}>
                No bank accounts available for fast coding. Connect a bank feed to use this feature
            </div>
        )}



      
    </div>  
   
)};

export default TransactionMenu;


// WEBPACK FOOTER //
// ./src/components/TransactionsMenu/TransactionMenu.js